import classNames from 'classnames';
import * as React from 'react';

type Size = 'small' | 'medium' | 'normal' | 'large';

interface Props {
    sizes: Size[];
    className?: string;
    children: React.ReactNode;
}

const Visible = ({ sizes, className, children }: Props) => (
    <div
        className={classNames(className, {
            'hidden--small': sizes.indexOf('small') === -1,
            'hidden--medium': sizes.indexOf('medium') === -1,
            'hidden--normal': sizes.indexOf('normal') === -1,
            'hidden--large': sizes.indexOf('large') === -1,
        })}
    >
        {children}
    </div>
);

export default Visible;
